import React from 'react';
import { Card } from '../ui/Card';
import { RadioGroup } from '../ui/RadioGroup';
import { Badge } from '../ui/Badge';
import { formatDate } from '../../utils/dateUtils';
interface Step5Props {
  data: {
    training: any;
    batch: any;
    schedules: any[];
    selectedTrainees: string[];
    isPublished: boolean;
  };
  onChange: (published: boolean) => void;
}
export function Step5Publish({
  data,
  onChange
}: Step5Props) {
  const {
    training,
    batch,
    schedules,
    selectedTrainees,
    isPublished
  } = data;
  return <div className="space-y-6" data-id="element-129">
      <Card title="Training Summary" data-id="element-130">
        <div className="space-y-4" data-id="element-131">
          <div className="grid grid-cols-2 gap-4" data-id="element-132">
            <div data-id="element-133">
              <p className="text-sm text-gray-600" data-id="element-134">Training Name (Bangla)</p>
              <p className="font-medium text-gray-900" data-id="element-135">
                {training.nameBangla || 'N/A'}
              </p>
            </div>
            <div data-id="element-136">
              <p className="text-sm text-gray-600" data-id="element-137">Training Name (English)</p>
              <p className="font-medium text-gray-900" data-id="element-138">
                {training.nameEnglish || 'N/A'}
              </p>
            </div>
          </div>

          <div className="grid grid-cols-2 gap-4" data-id="element-139">
            <div data-id="element-140">
              <p className="text-sm text-gray-600" data-id="element-141">Batch Name</p>
              <p className="font-medium text-gray-900" data-id="element-142">
                {batch.nameEnglish || 'N/A'}
              </p>
            </div>
            <div data-id="element-143">
              <p className="text-sm text-gray-600" data-id="element-144">Category</p>
              <p className="font-medium text-gray-900" data-id="element-145">
                {training.category || 'N/A'}
              </p>
            </div>
          </div>

          <div className="grid grid-cols-2 gap-4" data-id="element-146">
            <div data-id="element-147">
              <p className="text-sm text-gray-600" data-id="element-148">Training Dates</p>
              <p className="font-medium text-gray-900" data-id="element-149">
                {batch.startDate && batch.endDate ? `${formatDate(batch.startDate)} - ${formatDate(batch.endDate)}` : 'N/A'}
              </p>
            </div>
            <div data-id="element-150">
              <p className="text-sm text-gray-600" data-id="element-151">Duration</p>
              <p className="font-medium text-gray-900" data-id="element-152">
                {batch.duration || 0} Days
              </p>
            </div>
          </div>

          <div className="grid grid-cols-2 gap-4" data-id="element-153">
            <div data-id="element-154">
              <p className="text-sm text-gray-600" data-id="element-155">Venue Type</p>
              <Badge variant={batch.venueType === 'online' ? 'info' : 'default'} data-id="element-156">
                {batch.venueType === 'online' ? 'Online' : 'Offline'}
              </Badge>
            </div>
            <div data-id="element-157">
              <p className="text-sm text-gray-600" data-id="element-158">
                {batch.venueType === 'online' ? 'Meeting Link' : 'Venue Location'}
              </p>
              <p className="font-medium text-gray-900" data-id="element-159">
                {batch.venueType === 'online' ? batch.onlineLink || 'N/A' : batch.venueId || 'N/A'}
              </p>
            </div>
          </div>

          <div className="grid grid-cols-2 gap-4" data-id="element-160">
            <div data-id="element-161">
              <p className="text-sm text-gray-600" data-id="element-162">Total Sessions</p>
              <p className="font-medium text-gray-900" data-id="element-163">{schedules.length}</p>
            </div>
            <div data-id="element-164">
              <p className="text-sm text-gray-600" data-id="element-165">Total Participants</p>
              <p className="font-medium text-gray-900" data-id="element-166">
                {selectedTrainees.length}
              </p>
            </div>
          </div>
        </div>
      </Card>

      <Card title="Publish Training" data-id="element-167">
        <div className="space-y-4" data-id="element-168">
          <RadioGroup label="Publication Status" name="publishStatus" value={isPublished ? 'publish' : 'draft'} onChange={value => onChange(value === 'publish')} options={[{
          value: 'draft',
          label: 'Draft'
        }, {
          value: 'publish',
          label: 'Publish'
        }]} data-id="element-169" />

          {isPublished && <div className="bg-green-50 border border-green-200 rounded-lg p-4" data-id="element-170">
              <p className="text-sm text-green-900" data-id="element-171">
                Once published, the training will be visible in the system for
                attendance and certificate processing.
              </p>
            </div>}
        </div>
      </Card>
    </div>;
}